import * as React from "react";
import {useEffect } from "react";
import { Box, Typography, Link } from "@mui/joy";

const Terms: React.FC = () => {

   useEffect(() => {
       document.title = "Terms | Iskcon Kanpur";
   }, []);
   
  return (
    <Box
      sx={{
        maxWidth: "800px",
        margin: "auto",
        padding: "20px",
        textAlign: "left",
      }}
    >
      <Typography level="h1" fontSize="1.8rem" sx={{ mb: 2 }}>
        Terms & Conditions
      </Typography>
      <Typography level="body-md" sx={{ mb: 2 }}>
        Welcome to Iskcon Kanpur! These terms and conditions outline the rules
        and regulations for the use of our services.
      </Typography>

      <Typography level="h2" fontSize="1.5rem" sx={{ mt: 3, mb: 1 }}>
        1. Acceptance of Terms
      </Typography>
      <Typography level="body-md">
        By accessing this website, we assume you accept these terms and
        conditions in full. Do not continue to use Iskcon Kanpur if you do not
        accept all of the terms and conditions stated on this page.
      </Typography>

      <Typography level="h2" fontSize="1.5rem" sx={{ mt: 3, mb: 1 }}>
        2. User Responsibilities
      </Typography>
      <Typography level="body-md">
        - You must be at least 18 years old to use this service.
        <br />
        - You are responsible for maintaining the confidentiality of your
        account and password.
        <br />- You agree not to misuse our services for fraudulent activities.
      </Typography>

      <Typography level="h2" fontSize="1.5rem" sx={{ mt: 3, mb: 1 }}>
        3. Privacy Policy
      </Typography>
      <Typography level="body-md">
        Your use of our service is also governed by our{" "}
        <Link href="/privacy" target="_blank" rel="noopener noreferrer">
          Privacy Policy
        </Link>
        , which outlines how we collect and use your personal data.
      </Typography>

      <Typography level="h2" fontSize="1.5rem" sx={{ mt: 3, mb: 1 }}>
        4. Limitation of Liability
      </Typography>
      <Typography level="body-md">
        We shall not be held responsible for any damages arising from the use or
        inability to use our services.
      </Typography>

      <Typography level="h2" fontSize="1.5rem" sx={{ mt: 3, mb: 1 }}>
        5. Modifications to Terms
      </Typography>
      <Typography level="body-md">
        We reserve the right to update these terms at any time. Users are
        encouraged to review this page periodically for changes.
      </Typography>

      <Typography level="body-md" sx={{ mt: 3, fontStyle: "italic" }}>
        If you have any questions about our Terms & Conditions, please contact
        us.
      </Typography>
    </Box>
  );
};

export default Terms;
